import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserRole } from '@/hooks/useUserRole';
import { hasPermission } from '@/utils/roleManagement';
import { UserRole } from '@/types/userRole';

interface PrivateRouteProps {
  children: React.ReactNode;
  requiredRole?: UserRole;
  requiredPermission?: string;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  children,
  requiredRole,
  requiredPermission,
}) => {
  const { role, loading, isAuthenticated, dashboardPath } = useUserRole();

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth" replace />;
  }

  if (requiredRole && role !== requiredRole) {
    return <Navigate to={dashboardPath} replace />;
  }

  if (requiredPermission && !hasPermission(role as UserRole, requiredPermission)) {
    return <Navigate to={dashboardPath} replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
